// Fix AW (2026-10-27): roles personalizados (Equipo > Roles).
export const ROLES = {
  card: 'roles-card',
  addButton: 'roles-add-button',
  emptyState: 'roles-empty-state',
  rowPrefix: 'roles-row-', // + roleId
  editButtonPrefix: 'roles-edit-button-',
  deleteButtonPrefix: 'roles-delete-button-',

  dialog: 'roles-dialog',
  nameInput: 'roles-name-input',
  areaPrefix: 'roles-area-', // + area (inventory, payments, reports)
  saveButton: 'roles-save-button',
  cancelButton: 'roles-cancel-button',
  deleteConfirmButton: 'roles-delete-confirm-button',
  deleteCancelButton: 'roles-delete-cancel-button',
};
